import { ROUTES } from "../../../routes";

/**
 * Log analyzer paths.
 *
 * The analyzer mounts twice — publicly at `<base>/public` (site chrome, no
 * sign-in) and inside the app at `<base>` (app chrome). Shared components render
 * on both, so links must be derived from the mount the visitor is already on:
 * a hard-coded app path drops an anonymous visitor into the protected tree and
 * bounces them to login mid-flow.
 */
export const APP_BASE = ROUTES.logAnalyzer;
export const PUBLIC_BASE = `${APP_BASE}/public`;

export const basePath = (pathname = window.location.pathname) =>
  pathname.startsWith(PUBLIC_BASE) ? PUBLIC_BASE : APP_BASE;

export const logPath = (id, pathname) => `${basePath(pathname)}/${id}`;

/** Comparisons are app-only — there is no public compare route to fall back to. */
export const comparePath = (id) => `${APP_BASE}/compare/${id}`;
